import { Injectable } from '@angular/core';

import { OfferKind } from '@core/offers-types';
import { OfferSlotsLimitDialogComponent } from '@core/pricing-legacy';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';
import { BulkActionType } from '@recruitee/bulk-actions-legacy';
import { SubscriptionService } from '@recruitee/company-logic';

@Injectable()
export class OffersBulkActionsValidatorService {
  constructor(
    private subscription: SubscriptionService,
    private dialog: DialogService,
  ) {}

  public isActionPermitted(id: BulkActionType, ids: number[]) {
    switch (id) {
      case BulkActionType.RetrieveArchived:
        if (this.subscription.wouldCountExceedLimit(ids.length)) {
          this.openSlotsLimitDialog(ids.length);
          return false;
        }
        return true;
      default:
        return true;
    }
  }

  private openSlotsLimitDialog(offersCount: number): void {
    // IMO logic for validating slots limit and opening OfferSlotsLimitDialogComponent should
    //  be consolidated in one place. Now few services and components duplicates this logic
    this.dialog.openCustom(
      OfferSlotsLimitDialogComponent,
      { width: DialogWidth.Small },
      {
        offerKind: OfferKind.Job,
        isTrial: this.subscription.isTrial(),
        triggeredFromBulkCount: offersCount,
      },
    );
  }
}
